import { useEffect, useState } from 'react';
import { useCreateRemoveRetailPriceRangeFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBaseMetricRequestBuilder';
import { useMetricByWeekId } from 'src/serverProxy/useMetricByWeekId';
import { shouldShowBeaconProTopics } from 'src/utils/app';

/**
 * Hook to determine if traffic data is available
 */
export const useTrafficAvailability = () => {
  const removeRetailPriceRangeFilters = useCreateRemoveRetailPriceRangeFilters();
  const [dataAvailable, setDataAvailable] = useState(true);
  const { primaryTotal: totalClicks, isLoading: totalLoading } = useMetricByWeekId({
    useGenericAdvancedSearchArgs: {
      requestId: 'traffic-available-check'
    },
    indexName: 'aggregated-traffic',
    fieldName: 'totalClicks',
    requestBuilder: removeRetailPriceRangeFilters()
  });

  useEffect(() => {
    if (!totalLoading && totalClicks === 0) {
      setDataAvailable(false);
    } else {
      setDataAvailable(true);
    }
  }, [totalClicks, totalLoading]);
  return {
    dataAvailable: shouldShowBeaconProTopics() ? dataAvailable : true // Show empty pages until Topics is ready
  };
};
